// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentsList-Table_cls1__lH-8B","cls2":"PaymentsList-Table_cls2__h6QlC PaymentsList-Table_cls1__lH-8B"};